var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5Ire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.027 13.487a3.534 3.534 0 0 0 .045 5.026l8.195 7.989L21.97 15.843l-2.048-1.988-7.514 7.528a1.544 1.544 0 0 1-2.15.032L5.75 17.163a1.515 1.515 0 0 1-.029-2.18l12.341-12.27a3.605 3.605 0 0 0-4.706.35L3.027 13.487zm17.207-8.7L9.344 15.463l2.005 2.03 8.743-8.46 5.585 5.363c.612.588.625 1.558.028 2.161l-12.094 12.23a3.603 3.603 0 0 0 5.034-.075l10.327-10.424a3.534 3.534 0 0 0-.045-5.025l-4.347-4.238-4.346-4.238z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Ire);
export default __webpack_public_path__ + "static/media/5IRE.0024ce778f332cc02764d16ddc66e365.svg";
export { ForwardRef as ReactComponent };